
















































































































































































































































































































































































import { Component, Prop, Vue } from 'vue-property-decorator'
import './OrderReportListCard.scss'
import ExportPDF from './ExportPDF/ExportPDF.vue'
import constants from '@/utils/constants'
import { formatNumber } from '@/utils/helpers'
@Component({
  filters: {
    formatPrice(val: any) {
      let date: any = val
      return formatNumber(date)
    },
  },
  components: {
    ExportPDF,
  },
})
export default class OrderDetail extends Vue {
  @Prop() detailButton!: any
  @Prop(Array) item!: Array<any>
  @Prop(Boolean) detailButtonShow!: Boolean
  @Prop(Function) switchOrderDetail!: Function
  @Prop(Function) checkOutItems!: Function
  @Prop() currentDetailItem!: any
  @Prop(Function) disabledExportButtonState!: Function
  @Prop(Function) removeDisabled!: Function

  currentItem: Object = {}
  resItem: Object = {}
  isDeskTop: boolean = true
  constants: any = constants
  mounted() {
    if (this.item[0] === undefined) {
      this.checkOutItems()
      this.disabledExportButtonState()
    } else {
      this.removeDisabled()
    }
    if (this.item[0]) {
      this.switchOrderDetail(
        this.item[0].orderId,
        this.item[0].orderStatus,
        this.item[0].orderType,
        this.item[0].outletCode,
        this.item[0]
      )
    }
  }

  triggerDownload(orderType, orderID) {
    ;(this.$refs as any).isDownloadPDF.download(orderType, orderID)
  }
}
